<template>
  <div>
    <div class="account-user-sec">
      <div class="account-sec">
        <div class="account-top-bar">
          <div class="container">
            <div class="logo">
              <a ui-sref="login" title="Admin">
                <h4>Wohlig Backend</h4>
              </a>
            </div>
          </div>
        </div>
        <div class="acount-sec">
          <div class="container">
            <notifications group="foo" />
            <div class="row justify-content-md-center">
              <div class="col-md-4 col-md-offset-4">
                <div class="contact-sec formPart">
                  <b-form>
                    <!-- Email -->
                    <div>
                      <div
                        class="form-group"
                        :class="{ 'form-group--error': $v.user.email.$error }"
                      >
                        <label for="email">Email</label>
                        <input
                          type="email"
                          class="form-control"
                          id="email"
                          placeholder="name@gmail.com"
                          v-model.trim="user.email"
                          @input="setEmail()"
                        />
                        <div class="error" v-if="!$v.user.email.required && $v.user.email.$error">
                          Email is required
                        </div>
                      </div>
                    </div>
                    <!-- Email end -->
                    <!-- password -->
                    <div>
                      <label>Password</label>
                      <div
                        class="form-group floating-label-form-group controls"
                        :class="{ 'form-group--error': $v.user.password.$error }"
                      >
                        <div class="pass-box">
                          <input
                            type="password"
                            id="password"
                            class="form-control pass-box mr-2"
                            placeholder="Password"
                            v-model.trim="user.password"
                            @input="setPassword()"
                            required
                          />
                          <div class="input-group-addon icon-eye" v-if="!showPassword">
                            <a v-on:click="myPassword()">
                              <font-awesome-icon :icon="['far', 'eye-slash']" />
                            </a>
                          </div>
                          <div class="input-group-addon icon-eye" v-if="showPassword">
                            <a v-on:click="myPassword()">
                              <font-awesome-icon :icon="['fas', 'eye']" />
                            </a>
                          </div>
                        </div>
                        <div
                          class="error"
                          v-if="!$v.user.password.required && $v.user.password.$error"
                        >
                          Password is required
                        </div>
                      </div>
                    </div>
                    <div class="form-group text-center">
                      <router-link to="/viewUserList">
                        <button class="btn btn-primary px-5">Login</button>
                        <!-- <button type="button" v-on:click="login()">Login</button> -->
                      </router-link>
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { required, minLength, maxLength, between, sameAs, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      showPassword: "",
      errors: [],
      user: {
        email: "",
        password: ""
      },
      show: true
    };
  },
  validations: {
    user: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  methods: {
    login() {
      axios
        .post("http://localhost:3001/User/awsUrl", {
          url: "http://localhost:3001/User/createToken"
        })
        .then(response => {
          this.data = response.data;
          window.open(response.data);
        })
        .catch(error => {});
    },
    setEmail() {
      this.$v.user.email.$touch();
    },
    setPassword() {
      this.$v.user.password.$touch();
    },
    onSubmitUser(user) {
      if (this.user.username && this.user.password) {
      } else {
      }
      this.errors = [];

      if (!this.user.email) {
        this.errors.push("Login required.");
      }
      if (!this.user.password) {
        this.errors.push("Password required.");
      }
    },
    // onReset(evt) {
    //   evt.preventDefault();
    //   // Reset our form values
    //   this.form.email = "";
    //   this.form.password = "";
    //   // Trick to reset/clear native browser form validation state
    //   this.show = false;
    //   this.$nextTick(() => {
    //     this.show = true;
    //   });
    // },
    // for password
    myPassword() {
      const x = document.getElementById("password");
      if (x.type == "password") {
        x.type = "text";
        this.showPassword = true;
      } else {
        x.type = "password";
        this.showPassword = false;
      }
    }
  }
};
</script>
